/**
 * Formats a YYYY-MM-DD date as a short relative phrase - "Today",
 * "Yesterday", "N days ago" - falling back to a short absolute date once
 * it's more than a week out. Used by the Price Change attribute's
 * displays (ListingsDrawer card, PropertyModal) to show when a price
 * change happened; the 7-day price-change window means the fallback
 * shouldn't normally be reached.
 */
export function formatRelativeDate(dateStr) {
    try {
        const date = new Date(dateStr + 'T12:00:00');
        const now = new Date();
        const startOfDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        const startOfNow = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const diffDays = Math.round((startOfNow.getTime() - startOfDate.getTime()) / 86400000);
        if (diffDays <= 0)
            return 'Today';
        if (diffDays === 1)
            return 'Yesterday';
        if (diffDays < 7)
            return `${diffDays} days ago`;
        return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
    catch {
        return dateStr;
    }
}
//# sourceMappingURL=formatRelativeDate.js.map